module.exports = __webpack_public_path__ + "img/istj.62ba3141.png";